import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import {
  CloseIcon,
  FBIcon,
  InstagramIcon,
  YoutubeIcon,
} from "./Util/SVGIcons";

const MobileNavstyle = styled.div`
  //display: block;
  top: 0;
  position: fixed;
  z-index: 999;
  height: 100vh;
  width: 100vw;
  background-color: var(--color-white);
  transition: 200ms;
  animation: moveUp 200ms cubic-bezier(0.165, 0.84, 0.44, 1) forwards;

  @keyframes moveUp {
    0% {
      transform: translateX(150px);
    }
    100% {
      transform: translateX(0);
    }

    /* @media screen and (min-width: 992px) {
        display: none;
    } */
  }

  .container {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 50px 0;
  }
  .btn-close {
    width: 24px;
    height: 24px;
    position: absolute;
    right: 24px;
    top: 24px;

    button {
      background-color: transparent;
      border: none;
    }
  }
  .mobile-nav {
    width: 100%;

    font-family: var(--font-primary);

    ul {
      display: block;

      li {
        a {
          padding: 36px 16px 24px 16px;
          display: block;
          border-bottom: 1px solid var(--primary-grey-100);
        }

        a.current,
        a.active {
          font-weight: 500;
          border-bottom: 2px solid var(--color-secondary);
        }
      }
    }
  }

  .mobile-nav-socials {
    width: 100%;
    justify-self: end;
    margin-top: auto;

    ul {
      display: flex;
      gap: 30px;
      align-items: center;
      justify-content: space-evenly;
    }
  }
`;

function MobileNav(props) {
  const handleLinkClick = (e, callback) => {
    if (callback) {
      callback(e);
    }
    props.setTrigger(false);
  };

  return props.trigger ? (
    <MobileNavstyle>
      <div className="container">
        <div className="btn-close">
          <button onClick={() => props.setTrigger(false)}>
            <CloseIcon
              width={24}
              height={24}
              fill={"var(--primary-grey-300)"}
            />
          </button>
        </div>
        <div className="mobile-nav">
          <ul className="main-nav_top-level">
            <li>
              <NavLink
                to={"/"}
                activeClassName="current"
                onClick={(e) => handleLinkClick(e)}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to={"/about-us"}
                activeClassName="current"
                onClick={(e) => handleLinkClick(e)}
              >
                About
              </NavLink>
            </li>
            <li>
              <NavLink
                to={"/list-with-us"}
                onClick={(e) => handleLinkClick(e)}
              >
                List with us
              </NavLink>
            </li>
            <li>
              <NavLink to={"/services"} onClick={(e) => handleLinkClick(e)}>
                Services
              </NavLink>
            </li>
            <li>
              <NavLink to={"/contact-us"} onClick={(e) => handleLinkClick(e)}>
                Contact
              </NavLink>
            </li>
            {/* <li>
              <a href="#" onClick={(e) => handleLinkClick(e, openFormPopupListWithUs)} >Blog</a>
            </li>
            <li>
              <a href="#" onClick={(e) => handleLinkClick(e, openFormPopupListWithUs)} >
                My Items <span className="notif-items"></span>
              </a>
            </li> */}
          </ul>
        </div>

        <div className="mobile-nav-socials">
          <ul>
            <li className="ico-social ico-fb">
              <a
                href="https://www.facebook.com/Propeller.Realty/"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
              >
                <FBIcon />
              </a>
            </li>
            <li className="ico-social ico-ig">
              <a
                href="https://instagram.com/propeller.realty?igshid=OGQ2MjdiOTE="
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <InstagramIcon />
              </a>
            </li>
            <li className="ico-social ico-yt">
              <a
                href="https://www.youtube.com/@PropellerRealty"
                target="_blank"
                rel="noreferrer"
                aria-label="YouTube"
              >
                <YoutubeIcon />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </MobileNavstyle>
  ) : (
    ""
  );
}

export default MobileNav;
